<template>
  <div>
    <p v-if="faceMotifNonComId"
          :class="isFromLigneFace ? 'lien is-cursor-pointer' : ''"
          @click="saveInformationAndOpenPopUp(row, true)">
        {{ getLibelleFaceMotifNonCom(faceMotifNonComId) }}
    </p>
    <p v-else-if="affectations && (affectations.length > 1
    || (affectations.length === 1 && isFromLigneFace) )"
        class="lien is-cursor-pointer"
        @click="saveInformationAndOpenPopUp(row, false)">
      {{ getLibellesOfAffectations() }}
    </p>
    <template v-else-if="affectations && affectations.length === 1 && !isFromLigneFace">
      <router-link-blank
        v-if="getInformationDirection(affectations[0]).to"
        v-bind="getInformationDirection(affectations[0])">
      </router-link-blank>
      <p v-else> {{ getInformationDirection(affectations[0]).message }} </p>
    </template>
    <b-modal v-model="popUpAffectations" has-modal-card
             class="modal" v-if="affectations && faceInformation">
      <infoAffectationsFace :affectations="affectations"
                            :faceMotifNonComId="faceMotifNonComId"
                            :periode="periode"
                            :facesList="facesList"
                            :face="row"
                            :isFromLigneFace="isFromLigneFace"
                            :isLogistique="isLogistique"
                            :traduction="{
        title: $t('listeProduitFace.infoAffectation.title', { code: faceInformation }),
        noAffectation: $t('listeProduitFace.infoAffectation.noAffectation')}">

      </infoAffectationsFace>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatDate';
import { COMMANDER } from '@/configuration/affectation/affectationConf';
import { TYPE_COMMANDE, TYPE_DEVIS } from '@/configuration/devisConf';
import { AFFECTATION_RESEAU, CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import infoAffectationsFace from '@/components/general/p_infoAffectationsFace';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import messageErreur from '@/services/general/messageErreur';
import moment from 'moment';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    affectations: {
      type: Array,
      required: false,
      default: null,
    },
    row: {
      type: Object,
      required: true,
    },
    faceMotifNonComId: {
      type: String,
      default: null,
    },
    periode: {
      required: false,
      type: Object,
      default: null,
    },
    facesList: {
      type: Array,
      default: null,
    },
    isFromLigneFace: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      faceInformation: null,
      popUpAffectations: false,
    };
  },
  components: {
    infoAffectationsFace,
    routerLinkBlank,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    isLogistique() {
      return !!(this.affectations && this.affectations.length === 1
        && this.affectations[0].tournee);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getLibelleOfAffectation(affectation) {
      let libelle = affectation.libelle;
      if (this.isLogistique) libelle = affectation.tournee.libelle;
      if (affectation.commandeInterne
        && affectation.commandeInterne.societeId === this.societeActiveId) {
        libelle = affectation.commandeInterne.code;
      }
      if (affectation.typeReference === COMMANDER) {
        libelle += this.$i18n.t('listeProduitFace.infoAffectation.commande',
          { date: formatDate(affectation.dureeAffectation.dateFin) });
      }
      return libelle;
    },
    getLibellesOfAffectations() {
      if (this.isLogistique) return this.affectations[0].tournee.libelle;
      const affectationsALaDateJour = this.affectations.filter(el => {
        return moment().isBetween(el.dureeAffectation.dateDebut, el.dureeAffectation.dateFin, 'd', []);
      });
      if (!this.isFromLigneFace || affectationsALaDateJour.length > 1) return this.$i18n.t('listeFace.tab.multiple');
      if (affectationsALaDateJour.length) return affectationsALaDateJour[0].libelle;
      return this.affectations[0].libelle;
    },
    getLibelleFaceMotifNonCom(id) {
      if (!id) return '';
      const faceMotifNonComFind = this.parametre(
        PARAMETRES_KEYS.faceMotifNonCom,
      ).find((faceMotifNonCom) => { return faceMotifNonCom.id === id; });
      return faceMotifNonComFind ? faceMotifNonComFind.libelle : '';
    },
    saveInformationAndOpenPopUp(face, isFromMotif) {
      if (isFromMotif && !this.isFromLigneFace) return;
      if (face.reference) this.faceInformation = face.reference;
      else this.faceInformation = face.code;
      this.popUpAffectations = true;
    },
    getInformationDirection(affectation) {
      const info = { message: this.getLibelleOfAffectation(affectation), to: null };
      if (affectation.typeReference === TYPE_COMMANDE) {
        if (affectation.commandeInterne?.societeId === this.societeActiveId) {
          info.to = { name: 'c.bodac.commandes-venteInterne', params: { id: affectation.commandeInterne.id } };
        }
        info.to = { name: 'c.bodac.commandes', params: { id: affectation.referenceId } };
      }
      if (affectation.typeReference === TYPE_DEVIS) {
        info.to = { name: 'c.bodac.devis', params: { id: affectation.referenceId } };
      }
      if (affectation.typeReference === AFFECTATION_RESEAU) {
        const categorie = CATEGORIE_PRODUIT.find(c => c.code === affectation.sousTypeReference);
        if (categorie) {
          info.to = { name: categorie.routeDetail, params: { id: affectation.referenceId } };
        }
      }
      return info;
    },
  },
  async mounted() {
    try {
      await this.loadParametres([PARAMETRES_KEYS.faceMotifNonCom]);
      if (this.affectations && !this.isLogistique) {
        this.affectations.sort((a, b) => {
          return moment(b.dureeAffectation.dateDebut) - moment(a.dureeAffectation.dateDebut);
        });
      }
    } catch (error) {
      messageErreur(this.$i18n);
      throw error;
    }
  },
};
</script>
